import { z } from 'zod';
import { OnboardingAuditOverrideStatus } from '@mews-commander/data-access';
import { MAX_INPUT_TEXT_LENGTH, Validation } from '@mews/framework';

export const fieldNames = {
    overrideStatus: 'overrideStatus',
    notes: 'notes',
} as const;

export const schema = z.object({
    [fieldNames.overrideStatus]: z.nativeEnum(OnboardingAuditOverrideStatus).or(z.null()).default(null).optional(),
    [fieldNames.notes]: Validation.String.Required.max(MAX_INPUT_TEXT_LENGTH).default(''),
});

export type FormValues = z.infer<typeof schema>;
